<template>
	<div class="page">
		<div class="editionHeart" >
			<compCrumbs></compCrumbs>
		</div>
		<div class="goodsLine">
			<!-- <img src="../../../assets/img/cha.png" class="prevImg" @click="toPrev"/>
			<img src="../../../assets/img/cha.png" class="nextImg" @click="toNext"/> -->
			<div class="editionHeart">
				<div class="goodsR">
					<div class="goodsName">{{petDetail.petName}}</div>
					<div class="goodsNo">宠物ID：{{petDetail.epromNo}}</div>
					<div class="goodsSkuBox">
						<div class="goodsSkuItem" v-if="!$public.isNull(petDetail.age)">{{petDetail.age}}</div>
						<div class="goodsSkuItem" v-if="!$public.isNull(petDetail.petSex)">{{petDetail.petSex==='公'?'弟弟':'妹妹'}}</div>
						<div class="goodsSkuItem" v-if="!$public.isNull(petDetail.customFeatures)" v-for="(item) in petDetail.customFeatures" :key="item">{{item}}</div>
					</div>
					<div class="goodsAddrBox">
						<div class="label">配送至</div>
						<el-select v-model="addrValue" class="goodsAddrSelect" placeholder="请选择" @change="changeAddrValue">
							<el-option v-for="(item,index) in addrList" :key="index" :label="item.province_name+' '+item.city_name+' '+item.district_name" :value="index">
							</el-option>
						</el-select>
						<div style="font-size: 16px;color:#6A6A7E;line-height: 40px;">运费 ¥{{logistics}}</div>
					</div>
					<!-- <div class="goodsAddrBox">
						<div class="label">售后保障</div>
						<el-select v-model="dayValue" class="goodsAddrSelect" placeholder="请选择">
							<el-option v-for="item in [{ value: 'day30', label: '30天 无理由退换' }, { value: 'day100', label: '100天 宠物医疗保障' }]" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div> -->
					<div class="goodsAddrBox">
						<div class="label">售后保障</div>
						<div style="padding:30px 0;">
							<img style="margin-right: 20px;height: 100px;" src="../../../assets/img/order/service30.png"/>
							<img style="margin-right: 20px;height: 100px;" src="../../../assets/img/order/service100.png"/>
						</div>
					</div>
					<div class="goodsBtn">
						<div class="submit" v-if="lockData.status===0||lockData.memberId===userInfo.userId" @click="submit">立即购买 ￥{{petDetail.price}}</div>
						<div class="submit" v-else style="background-color: #CFCFD8;">已被锁定 ( {{Math.floor($public.chu(onlyTime,60))}}分{{onlyTime%60}}秒 )</div>
						<el-popover placement="top-start" width="200" trigger="hover">
							<img src="../../../assets/img/goods/downloadApp.png" style="width:200px;height: 200px;"/>
							<div class="download" slot="reference"><img src='../../../assets/img/goods/download.png' style="vertical-align: middle;margin-right: 6px;"/>下载花生宠物App</div>
						</el-popover>
					</div>
				</div>
				<div v-if="!$public.isNull(petDetail.petId)" class="goodsL">
					<compLivingBanner :petDetail="petDetail"></compLivingBanner>
				</div>
			</div>
		</div>
		<img class="title1Img" src="../../../assets/img/goods/petDesc.png"/>
		<div class="detailLine">
			<div class="editionHeart">
				<div class="detailLabel">
					<span style="color:#F66900;">宠物</span>详情
				</div>
				<div class="detailList">
					<div class="detailItem" >
						宠物祖籍：<span style="color:#37374C;">{{petDetail.ancestralHome}}</span>
					</div>
					<div class="detailItem" >
						宠物生日：<span style="color:#37374C;">{{$public.FTime(petDetail.bronDate,"YYYY-MM-DD")}}</span>
					</div>
					<div class="detailItem" >
						宠物性别：<span style="color:#37374C;">{{petDetail.petSex}}</span>
					</div>
					<div class="detailItem" >
						宠物毛色：<span style="color:#37374C;">{{petDetail.petColor}}</span>
					</div>
					<div class="detailItem" >
						宠物品级：<span style="color:#37374C;">{{petDetail.petGrade?petDetail.petGrade.name:''}}</span>
					</div>
					<div class="detailItem" >
						宠物ID：<span style="color:#37374C;">{{petDetail.epromNo}}</span>
					</div>
					<div class="detailItem" v-if="!$public.isNull(petDetail.customFeatures)">
						宠物特征：<span style="color:#37374C;" v-for="item in petDetail.customFeatures">{{item}} </span>
					</div>
				</div>
			</div>
		</div>
		<div class="detailLine" style="background-color: #fff;">
			<div class="editionHeart">
				<div class="detailLabel">
					<span style="color:#F66900;">疫苗</span>计划
				</div>
				<div class="detailTable" v-if="$public.isNull(petDetail.vaccinesInfo)">
					暂无疫苗信息
				</div>
				<div class="detailTable" v-else>
					<div class="detailTableRow" v-for="(item,index) in petDetail.vaccinesInfo" :key="index">
						<div class="detailTableCell0">{{item.planName}}</div>
						<div class="detailTableCell1">{{item.medicalName}}</div>
						<!-- <div class="detailTableCell2">未知</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="detailLine">
			<div class="editionHeart">
				<div class="detailLabel">
					<span style="color:#F66900;">花生百天</span>保障
				</div>
				<div class="detailText" v-for="(item,index) in dict.children" :key="index">
					<span v-if="item.value==='2'">{{item.tips}}</span>
				</div>
			</div>
		</div>
		<div class="detailLine">
			<div class="editionHeart">
				<div class="detailLabel">
					<span style="color:#F66900;">花生30天</span>无理由换宠
				</div>
				<div class="detailText" v-for="(item,index) in dict.children" :key="index">
					<span v-if="item.value==='1'">{{item.tips}}</span>
				</div>
			</div>
		</div>
		<div v-if="!$public.isNull(petDetail.detailImgList)" class="editionHeart">
			<img v-for="(item,index) in petDetail.detailImgList" :key="index" style="width:100%;" :src="item"/>
		</div>
	</div>
</template>

<script>
	import compLivingBanner from "./comp_livingBanner.vue"
	import compCrumbs from "../../../components/compCrumbs.vue"
	export default {
		components:{compLivingBanner,compCrumbs},
		data() {
			return {
				petDetail:{},
				
				addrValue:'',
				addrList:[],
				logistics:0, // 运费
				dayValue:'',
				
				// 字典
				dict:{},
				// 锁定判断
				lockData:{
					memberId: "",
					status: 0,
					time: '',
				},
				timer:null,
				onlyTime:0,
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			}
		},
		watch:{
			userInfo(){
				this.getAddressList()
			}
		},
		mounted(){
			this.getDict()
			this.getPetDetail()
			this.getAddressList()
		},
		methods:{
			toPrev(){
				
			},
			toNext(){
				
			},
			submit(){
				this.$router.push({
					path:'/order/livingOrderAdd',
					query:{ 
						id:this.petDetail.petId, 
						dayValue:this.dayValue, 
						addrValue:this.addrValue?this.addrList[this.addrValue]._id:'' 
					},
				})
			},
			getPetDetail(){
				let params = {
					id:this.$route.query.id
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/Pet/detail/info', params).then(res => {
					loading.close()
					if(res.code===0){
						this.petDetail = res.data
						this.getLockState()
					}
				})
			},
			// 收货地址
			getAddressList(){
				if(this.$public.isNull(this.userInfo)){
					return ;
				}
				let params = {}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/ShipAddress/list', params).then(res => {
					loading.close()
					if(res.code===0){
						this.addrList = res.data
					}
				})
			},
			changeAddrValue(index){
				let curAddr = this.addrList[index]
				let params = {
					"orderType": "1",  // 订单类型 o:商品订单 1:活体订单
					"province": curAddr.province_name,
					"city": curAddr.city_name,
					"orderAmount": this.petDetail.price,  // 订单金额
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_livingMall+'/api/Logistics/calc/Freight', params).then(res => {
					loading.close()
					if(res.code===0){
						if(res.data.support===0){
							this.$message({
								type: 'error',
								message: res.data.info
							});
							this.logistics = 0
						}else{
							this.logistics = res.data.amount
						}
						
					}
				})
			},
			getDict(){
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/DataBase/dict/single', {
					id:"APP_CWQY",
				}).then(res => {
					loading.close()
					if(res.code===0){
						this.dict = res.data
					}
				})
			},
			getLockState(){
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_baseData+'/api/product/pet/lock/status', {
					id:this.petDetail.petId,
				}).then(res => {
					loading.close()
					if(res.code===0){
						this.lockData = res.data
						if(this.lockData.status===1){
							this.timer = setInterval(()=>{
								let n = this.$public.chu(new Date().getTime(),1000)
								let c = Math.floor(n) - (this.lockData.time)
								this.onlyTime = 600 - c;
								if(this.onlyTime<1){
									this.getPetDetail()
									clearInterval(this.timer)
								}
							},1000)
						}
					}
				})
			},
		},
		beforeDestroy(){
			clearInterval(this.timer)
		},
	}
</script>

<style lang="scss" scoped>
.page{
	.goodsLine{
		padding-top:0px;position: relative;
		.prevImg{
			position: absolute;top:200px;left: calc(50% - 645px);z-index: 1;cursor: pointer;
		}
		.nextImg{
			position: absolute;top:200px;left: calc(50% + 616px);z-index: 1;cursor: pointer;
		}
		.editionHeart{
			display: flex;flex-direction: row-reverse;
			.goodsL{
				width:440px;
			}
			.goodsR{
				width:calc(100% - 440px);padding-left:50px;box-sizing: border-box;
				.goodsName{
					font-size: 32px;color:#303042;padding-top:30px;
				}
				.goodsNo{
					font-size: 18px;color:#818096;padding-top:16px;
				}
				.goodsSkuBox{
					display: flex;flex-wrap: wrap;padding-top:32px;
					.goodsSkuItem{
						min-width:138px;line-height: 46px;border:1px solid #9A52FF;background-color: #F4EFFF;font-size: 18px;color:#7326E9;text-align: center;margin:0 10px 10px 0;padding:0 10px;box-sizing: border-box;
						&:nth-child(3n){
							border:1px solid #F78F00;background-color: #FFF7EA;font-size: 18px;color:#FF8400;
						}
					}
				}
				.goodsAddrBox{
					display: flex;padding-top: 32px;
					.label{
						width:100px;line-height: 40px;font-size: 18px;color:#6A6A7E;
					}
					.goodsAddrSelect{
						width: 350px;margin-right: 10px;
					}
				}
				.goodsBtn{
					display: flex;
					.submit{
						width:350px;line-height: 72px;background-color: #35353B;font-size: 22px;color:#FFFFFF;text-align: center;cursor: pointer;margin:72px 10px 0 100px;
					}
					.download{
						line-height: 72px;background-color: #fff;font-size: 16px;color:#76758A;text-align: center;cursor: pointer;margin:72px 10px 0 20px;border:1px solid #76758A;width:200px;
					}
				}
			}
		}
	}
	.title1Img{
		height: 107px;margin:auto;display: block;padding-top:100px;padding-bottom:10px;
	}
	.detailLine{
		background-color: #F6F6F8;padding:40px 0;
		.editionHeart{
			.detailLabel{
				font-size: 22px;color:#303042;font-weight: bold;
			}
			.detailList{
				display: flex;flex-wrap: wrap;
				.detailItem{
					width:20%;padding:40px 0 0;
				}
			}
			.detailTable{
				padding-top:32px;
				.detailTableRow{
					font-size: 18px;display: flex;border-bottom:1px solid #CFCFD8;
					&:nth-child(2n-1){
						background-color: #F6F6F8;
					}
					.detailTableCell0{
						color:#37374C;padding:24px 32px;width:220px;box-sizing: border-box;
					}
					.detailTableCell1{
						color:#37374C;padding:24px 32px;width:790px;box-sizing: border-box;
					}
					.detailTableCell2{
						color:#37374C;padding:24px 32px;width:160px;box-sizing: border-box;
					}
				}
			}
			.detailText{
				font-size: 18px;color:#9796AC;padding-top:20px;line-height: 30px;
			}
		}
	}
}
</style>							
